<template lang="pug">
  extends TableRowBase.pug
</template>

<script>
  import TableRowBase from './TableRowBase.vue';

  export default {
    name: 'TableRowNumAudiosToGeneratePurchase',
    extends: TableRowBase,
    computed: {
      closestBenchmark() {
        // Check that this metric has benchmark data
        if (this.lowValue === undefined || this.medianValue === undefined || this.highValue === undefined) {
          return 'unknown';
        }
        if (this.actualYtdRaw === 0) {
          return 'low';
        }
        return lodash.chain(this.benchmarkDiffArray).sortBy(['diffValue']).first().get('name').value();
      },
    },
    methods: {
      getCalculatedYtd(yearObj, throughMonth) {
        return this.getRatio(
          this.getYtdByField(yearObj, 'number_audiograms', throughMonth),
          this.getYtdByField(yearObj, 'number_patients_purchased', throughMonth),
        );
      },
    },
  };
</script>
